import {Injectable} from '@angular/core';
import {Config} from "../../models/config/config.interface";
import {Entry} from "../../models/entry/entry.interface";
import moment from "moment";

//const entryToday = 0;

@Injectable()
export class DataCheckProvider {

    private entryDirty: boolean;

    deviceTypeList = [{ key:'home-choice-pro', value:'Home Choice Pro'}, {key:'sleep-safe-now', value:'Sleep Safe Now'}, {key:'sleep-safe-harmony', value:'Sleep Safe Harmony' }];

    //due to #6999 (adding of additional dialysat fliuid, key's are handleded a bit differently, we now show the value in the pdf with name (bicavera or balance))
    // var name dialysatBicaVera was changed to dialysatFluidList
    //public dialysatBicaVera = [{ key:1.5, value:'BicaVera 1,5%'}, {key:2.3, value:'BicaVera 2,3%'}, {key:4.25, value:'BicaVera 4,25%' }];
    public dialysatFluidList = [
                                    { key:1.5, value:'BicaVera 1,5%'}, {key:2.3, value:'BicaVera 2,3%'}, {key:4.25, value:'BicaVera 4,25%' },
                                    { key:5, value:'balance 1,5% / 1,25 mmol'}, {key:6, value:'balance 2,3% / 1,25 mmol'}, {key:7, value:'balance 4,25% / 1,25 mmol' },
                                    { key:8, value:'balance 1,5% / 1,75 mmol'}, {key:9, value:'balance 2,3% / 1,75 mmol'}, {key:10, value:'balance 4,25% / 1,75 mmol' },
                                    { key:11, value:'PHYSIONEAL40 1,36%/13,6'}, {key:12, value:'PHYSIONEAL40 2,27%/22,7'}, {key:13, value:'PHYSIONEAL40 3,86%/38,6' },
                                    { key:14, value:'PHYSIONEAL Nutrineal'}, {key:15, value:'PHYSIONEAL Extraneal'}, {key:16, value:'PHYSIONEAL35 1,36%/13,6' },
                                    { key:17, value:'PHYSIONEAL35 2,27%/22,7'}, {key:18, value:'PHYSIONEAL35 3,86%/38,6'}

                              ];

    public gesamtablaufJeden = [ { key:1, value:'1.'}, { key:2, value:'2.'} ,{ key:3, value:'3.'},
                                  { key:4, value:'4.'}, { key:5, value:'5.'} ,{ key:6, value:'6.'},
                                  { key:7, value:'7.'}, { key:8, value:'8.'} ,{ key:9, value:'9.'},
                                ];


    constructor() {
    }

    isPatientConfigComplete(conf: Config): boolean {
        //console.log("####  config.obergrenzeGewicht=====" + conf.obergrenzeGewicht);
        return !(this.isValueInvalid(conf.obergrenzeGewicht) ||
            this.isValueInvalid(conf.untergrenzeGewicht) ||
            this.isValueInvalid(conf.obergrenzeSystole) ||
            this.isValueInvalid(conf.untergrenzeSystole) ||
            this.isValueInvalid(conf.obergrenzeDiastole) ||
            this.isValueInvalid(conf.untergrenzeDiastole) ||
            /*#6720:  commenting out
            this.isValueInvalid(conf.obergrenzeMAD) ||
            this.isValueInvalid(conf.untergrenzeMAD) ||
            */
            this.isValueInvalid(conf.obergrenzeTemperatur) ||
            this.isValueInvalid(conf.untergrenzeTemperatur) ||
            /*conf.limitAdditiveESS === undefined || (typeof conf.limitAdditiveESS != 'number') ||
            conf.limitSingleESS === undefined || (typeof conf.limitSingleESS != 'number') ||*/
            this.isInvalidEES(conf.limitAdditiveESS) ||
            this.isInvalidEES(conf.limitSingleESS) ||
            conf.nachname === undefined || conf.nachname == "" ||
            conf.vorname === undefined || conf.vorname == "" ||
            conf.geburtstag === undefined);
    }

    isValueInvalid(varItem) {
        return varItem === undefined || varItem == 0 || (typeof varItem != 'number');
    }

    isInvalidEES(varItem) {
        if (varItem && (typeof varItem == 'string')) {
            let s1 = varItem + "";
            s1 = s1.trim();
            if (s1.length > 0) {
                //console.log("AAAAA BBBBB CCCCCCC");
                varItem = parseInt(s1.trim());
                //console.log("varItem is a---->" + typeof varItem);
            }
        }

        return varItem === undefined || varItem == 0 || (typeof varItem != 'number');
    }


    createConfigErrorAlertMessage(conf: Config, isConfigPage: boolean): string {

        //console.log("in DataCheckProvider.createConfigErrorAlertMessage()->  config.obergrenzeGewicht=====" + conf.obergrenzeGewicht);

        let errorStr = "<p>Bevor Du mit der Datenerfassung beginnst, erfasse bitte persönliche Daten und Wertebereiche in den Einstellungen.</p>";
        if (isConfigPage) {
            errorStr = "<p>Bevor Du mit der Datenerfassung beginnst, erfasse bitte persönliche Daten und Wertebereiche.</p>";
        }

        errorStr = errorStr + "<ul>";

        if (conf.nachname === undefined || conf.nachname.trim().length == 0) {
            errorStr = errorStr + "<li>Nachname</li>";
        }
        if (conf.vorname === undefined || conf.vorname.trim().length == 0) {
            errorStr = errorStr + "<li>Vorname</li>";
        }
        if (conf.geburtstag === undefined) {
            errorStr = errorStr + "<li>Geburtstag</li>";
        }
        if (this.isInvalidEES(conf.limitAdditiveESS)) {
            errorStr = errorStr + "<li>Limit additive ESS</li>";
        }
        if (this.isInvalidEES(conf.limitSingleESS)) {
            errorStr = errorStr + "<li>Limit einzelne ESS</li>";
        }
        if (this.isValueInvalid(conf.untergrenzeGewicht)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Gewichtszuwachs (Untergrenze) </li>";
        }
        if (this.isValueInvalid(conf.obergrenzeGewicht)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Gewichtszuwachs (Obergrenze) </li>";
        }
        if (this.isValueInvalid(conf.obergrenzeSystole)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Systole (Obergrenze) </li>";
        }
        if (this.isValueInvalid(conf.untergrenzeSystole)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Systole (Untergrenze) </li>";
        }
        if (this.isValueInvalid(conf.untergrenzeDiastole)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Diastole (Untergrenze) </li>";
        }
        if (this.isValueInvalid(conf.obergrenzeDiastole)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Diastole (Obergrenze) </li>";
        }
        /*
        // #6720: commenting out
        if (this.isValueInvalid(conf.untergrenzeMAD)) {
            errorStr = errorStr + "<li>Zielbereich tägl. MAD (Untergrenze) </li>";
        }
        if (this.isValueInvalid(conf.obergrenzeMAD)) {
            errorStr = errorStr + "<li>Zielbereich tägl. MAD (Obergrenze) </li>";
        }
        */
        if (this.isValueInvalid(conf.obergrenzeTemperatur)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Temperatur (Obergrenze) </li>";
        }
        if (this.isValueInvalid(conf.untergrenzeTemperatur)) {
            errorStr = errorStr + "<li>Zielbereich tägl. Temperatur (Untergrenze) </li>";
        }

        errorStr = errorStr + "</ul>";

        return errorStr;
    }

    createNoConfigErrorAlertMessage(): string {
        return "<p>Bevor Du mit der Datenerfassung beginnst, erfasse bitte persönliche Daten und Wertebereiche in den Einstellungen.</p>";
    }

    getFullNameOfPatient(conf: Config): string {
        let vorName = conf.vorname;
        let nachName = conf.nachname
        if (!vorName) vorName = "";
        if (!nachName) nachName = "";

        let fullname = vorName + " " + nachName;

        return fullname.trim();
    }

    getPatientBirthdate(conf: Config): string {
        let bDate = "";
        if (conf.geburtstag) {
            bDate = conf.geburtstag + "";
        }
        return bDate.trim();
    }

    getEntryDirty():boolean {
        return this.entryDirty;
    }

    setEntryDirty(iBoolVal) {
        this.entryDirty = iBoolVal;
    }

    //#6782: to iso local (https://stackoverflow.com/questions/49330139/date-toisostring-but-local-time-instead-of-utc)
    public static toISOLocal(d) {
        const z = n => ('0' + n).slice(-2);
        let off = d.getTimezoneOffset();
        const sign = off < 0 ? '+' : '-';
        off = Math.abs(off);
        return new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().slice(0, -1) + sign + z(off / 60 | 0) + ':' + z(off % 60);
    }

    //alertGewicht always have to be measured dynamically from current day and prev day.
    //if no data for prev day, then NO alertGewicht will be calculated.
    //alertGewicht is the delta value from  a day and the day before.
    //#6800
    getAlertGewicht(iEntry:Entry, entries: Entry[]): boolean {
        let alertGewicht = false;
        if (entries.length > 1) {
            let iDateShortSort = iEntry.referenzDatumShortSort;
            let prevDateShortSort = this.getRequiredRefDateShortSort(iDateShortSort, 1); //#6770

            // following will give problem for 1st March (20210301) ---> 20210301 -1 = 20210300 (is not 28th Feb)
            //let prevDateShortShort = iEntry.referenzDatumShortSort-1;

            let idx = entries.findIndex(item => item.referenzDatumShortSort == iDateShortSort);
            let idxPrev = entries.findIndex(item => item.referenzDatumShortSort == prevDateShortSort);

            if (idx >=0 && idxPrev >=0) {
                let prevEntry = entries[idxPrev];
                alertGewicht = this.getAlertGewichtByPrevEntry(iEntry, prevEntry);
            }
        }
        return alertGewicht;
    }

    //#6770
    // following will give problem for 1st March (20210301) ---> 20210301 -1 = 20210300 (is not 28th Feb)
    //let prevDateShortShort = iEntry.referenzDatumShortSort-1;
    public getRequiredRefDateShortSort(refDateShortSort: number, diffDays:number):number {
        let diffDateMoment =  moment(refDateShortSort+"", 'YYYYMMDD').subtract(diffDays, 'days');
        let diffDateShortSortStr = diffDateMoment.format('YYYYMMDD');
        let diffDateShortSort = Number(diffDateShortSortStr);

        return diffDateShortSort;
    }

    getAlertGewichtByPrevEntry(iEntry:Entry, prevEntry:Entry): boolean {
        let alertGewicht = false;
        if (iEntry && prevEntry) {
            let currentWeight = iEntry.gewicht;
            let prevWeight = prevEntry.gewicht;
            if (currentWeight && prevWeight) {
                let deltaVortag = currentWeight - prevWeight;
                if (deltaVortag < iEntry.historischeUntergrenzeGewicht || deltaVortag > iEntry.historischeObergrenzeGewicht ) {
                    alertGewicht = true;
                }
            }
        }
        return alertGewicht;
    }

    getDeltaGewichtVorTag(iEntry:Entry, entries: Entry[]): number {
        let deltaGewicht = this.getDeltaGewichtByDays(iEntry, entries, 1);
        return deltaGewicht;
    }

    getDeltaGewichtByDays(iEntry:Entry, entries: Entry[], diffDays:number): number {
        let deltaGewicht = 0;
        if (entries.length > 1) {
            let iDateShortShort = iEntry.referenzDatumShortSort;

            // following will give problem for 1st March (20210301) ---> 20210301 -1 = 20210300 (is not 28th Feb)
            // let diffDateShortShort = iEntry.referenzDatumShortSort - diffDays;
            let diffDateShortShort = this.getRequiredRefDateShortSort(iDateShortShort, diffDays) ;

            let idx = entries.findIndex(item => item.referenzDatumShortSort == iDateShortShort);
            let idxDiff = entries.findIndex(item => item.referenzDatumShortSort == diffDateShortShort);

            if (idx >=0 && idxDiff>=0) {
                let prevEntry = entries[idxDiff];
                let currentWeight = iEntry.gewicht;
                let prevWeight = prevEntry.gewicht;
                if (currentWeight && prevWeight) {
                    deltaGewicht = currentWeight - prevWeight;
                }
            }
        }
        return deltaGewicht;
    }

    getAlertGewichtFromTwoWeights(currentWeight:number, prevDayWeight:number, historischeUntergrenzeGewicht,historischeObergrenzeGewicht ): boolean {
        let alertGewicht = false;
        if (currentWeight && prevDayWeight) {
            //console.log(`AAAAAA currentWeight=${currentWeight} and prevDayWeight=${prevDayWeight}`);
            let deltaVortag = currentWeight - prevDayWeight;
            if ((deltaVortag < historischeUntergrenzeGewicht) || (deltaVortag > historischeObergrenzeGewicht)) {
                alertGewicht = true;
            }
        }
        return alertGewicht;
    }
    // for a given date, check if weight was given
    wasWeightRecorded (entries: Entry[], dateShortShort):boolean  {
        let hasWeightEntry = false;
        let idx = entries.findIndex(item => item.referenzDatumShortSort == dateShortShort);
        if (idx >= 0) {
            let iEntry = entries[idx];
            let iWeight = iEntry.gewicht;
            if (iWeight && iWeight >= 0) {
                hasWeightEntry = true;
            }
        }
        return hasWeightEntry;
    }

    /*******************************info and statistics methods ***************************************************/

    //Note: entries is a array where latest entry is at index 0.
    // we get this array from firebase sorted by 'sortierDatum'

    /**
     * Return the current value for a given property
     * Returns null if no value could be found for given day
     */
    public static getValue(entries: Entry[], day: number, propertyString: string): number {
        return (entries[day]) ? entries[day][propertyString] || null : null;
    }

    /**
     * Return the delta compared to actual value for a given property
     */
    public static getDelta(entries: Entry[], day: number, propertyString: string): number {
        // get current value
        let today = 0;
        return this.getDeltaBetween2Days(entries, today, day, propertyString);

    }

    /**
     * Return the delta of a given properties between day1 and day2
     */
    public static getDeltaBetween2Days(entries: Entry[], day1: number, day2: number, propertyString: string): number {
        // get current value
        const current = DataCheckProvider.getValue(entries, day1, propertyString);
        const comparedWith = DataCheckProvider.getValue(entries, day2, propertyString);

        if (!current || !comparedWith) {
            // no delta possible
            return null;
        }

        return current - comparedWith;
    }

    /**
     * Return the delta compared to actual value for a given property
     */
    public static getDeltaWarning(entries: Entry[], day: number, propertyString: string): boolean {
        // get current value
        const delta = DataCheckProvider.getDelta(entries, day, propertyString);

        return delta === null;
    }

    /**
     * Return the delta compared to actual value for a given property
     * deltaGewicht must be compared with historischeUntergrenzeGewicht and historischeObergrenzeGewicht
     */
    public static getDeltaWarningGewicht(entries: Entry[], day: number, propertyString: string): boolean {
        if (day == 0) {
            return false;
        }
        return DataCheckProvider.getDeltaWarningGewichtBetweenTwoDays(entries, 0, day, propertyString );
    }

    public static getDeltaWarningGewichtBetweenTwoDays(entries: Entry[], dayIdx1:number, dayIdx2: number, propertyString: string): boolean {
        if (dayIdx2 == 0 || dayIdx1 == dayIdx2) {
            return false;
        }
        // get current value
        const delta = DataCheckProvider.getDeltaBetween2Days(entries, dayIdx1, dayIdx2, propertyString);

        let historischeUntergrenzeGewicht = DataCheckProvider.getValue(entries, dayIdx1, "historischeUntergrenzeGewicht"); // weight lower limit
        let historischeObergrenzeGewicht = DataCheckProvider.getValue(entries, dayIdx1, "historischeObergrenzeGewicht"); // weight upper limit

        if (historischeUntergrenzeGewicht && historischeObergrenzeGewicht) {
            let totalLowerLimitWeight = historischeUntergrenzeGewicht * (dayIdx2 -dayIdx1); // total lower weight limit
            let totalUpperLimitWeight = historischeObergrenzeGewicht * (dayIdx2 -dayIdx1); // total upper weight limit

            return  ((delta != null && (delta < totalLowerLimitWeight || delta > totalUpperLimitWeight)) ? true: false);
        }

        return false;
    }

    /**
     * Get average for given property and time frame
     */
    public static getAverage(entries: Entry[], day: number, propertyString: string): number {
        const validEntries = entries
            .slice(0, day + 1)
            .map(e => +e[propertyString])
            .filter(n => n !== null)
            .filter(n => !isNaN(n))
            .filter(n => n !== 0)
        ;

        if (validEntries.length == 0) return null;

        const sum = validEntries.reduce((a, b) => a + b);
        const numberOfElements = validEntries.length;

        if (numberOfElements === 0) return null;
        return sum / numberOfElements;
    }

    /**
     * Get average for given property and between a timeFrame (dayIdx1 and dayIdx2)
     */
    public static getAverageBetween2Days(entries: Entry[], dayIdx1: number, dayIdx2: number, propertyString: string): number {
        const validEntries = entries
            .slice(dayIdx1, dayIdx2 + 1)
            .map(e => +e[propertyString])
            .filter(n => n !== null)
            .filter(n => !isNaN(n))
            .filter(n => n !== 0)
        ;

        if (validEntries.length == 0) return null;

        const sum = validEntries.reduce((a, b) => a + b);
        const numberOfElements = validEntries.length;

        if (numberOfElements === 0) return null;
        return sum / numberOfElements;
    }

    /**
     * return warning = true if we have missing data
     */
    public static getAverageWarning(entries: Entry[], day: number, propertyString: string): boolean {
        const numberOfElements = entries
            .slice(0, day + 1)
            .map(e => e[propertyString] as number)
            .filter(n => n != null)
            .filter(n => !isNaN(n))
            .filter(n => n !== 0)
            .length;
        return (numberOfElements !== day + 1);
    }

    /**
     * Get delta average for given property and time frame
     */
    public static getDeltaAverage(entries: Entry[], day: number, propertyString: string): number {
        // find the oldest values starting from index to 0 ("backwards")
        let delta = null;
        for (var i = day; i > 0; i--) {
            delta = DataCheckProvider.getDelta(entries, i, propertyString);
            if (delta !== null) break;
        }

        if (delta === null) {
            return null;
        }

        return delta / day;
    }

    /**
     * Get delta average for given property and between dayIdx1 and dayIdx2
     */
    public static getDeltaAverageBetween2Days(entries: Entry[], dayIdx1: number, dayIdx2: number, propertyString: string): number {

        if (dayIdx1 > dayIdx2 || dayIdx1== dayIdx2) {
            return null;
        }

        // find the oldest values starting from dayIdx2 to dayIdx1 ("backwards")
        let delta = null;
        for (var i = dayIdx2; i > dayIdx1; i--) {
            delta = DataCheckProvider.getDeltaBetween2Days(entries, dayIdx1, i , propertyString);
            if (delta !== null) break;
        }

        if (delta === null) {
            return null;
        }

        return delta / (dayIdx2 - dayIdx1);
    }

    /**
     * return warning = true if we have missing data
     */
    public static getDeltaAverageWarning(entries: Entry[], day: number, propertyString: string): boolean {
        return DataCheckProvider.getDelta(entries, day, propertyString) === null;
    }

    /**
     * This generates an array with arraySize (default is 30) entries.
     * Fill entries into the array so that the current entry is index 0.
     * If there is no entry for a given day, then it is null.
     * If value exists for today - this value has index 0
     * If value does not exist for today, but for yesterday - this value has index 0
     */
    public static generateTimeEntryArray(entries: Entry[], arraySize: number = 30): Entry[] {
        // sanity check
        if (entries.length == 0) return [];

        const timeEntries: Entry[] = [];

        // 30 entries
        //timeEntries.fill(null, 0, 30)
        timeEntries.fill(null, 0, arraySize)

        const sortedArray = DataCheckProvider.sortEntries(entries);
        sortedArray.forEach(entry => {
            const referenzDateMoment = moment(entry.referenzDatum.toString());
            const index = moment().startOf('day').diff(referenzDateMoment.startOf('day'), 'day');

            if (index <= arraySize) timeEntries[index] = entry;
        });

        return timeEntries;
    }

    /**
     * Sort entries by sortierdatum ,either ascending (default) or descending
     * @param entries the entries to sort
     * @param ascending up or down sorting
     */
    private static sortEntries(entries: Entry[], ascending: boolean = true): Entry[] {
        const sortedEntries = entries.sort((a, b) => a.sortierDatum > b.sortierDatum ? 1 : a.sortierDatum > b.sortierDatum ? -1 : 0);
        if (!ascending) sortedEntries.reverse();
        return sortedEntries
    }

    /********************************************************************************************/

    //#6773, #6917, #6918
    public static getUltrafiltrationWithHandwechsels(ultrafiltration: number, handwechsels):number {

        if (!ultrafiltration && !handwechsels) {
            return null;
        }

        let ultrafiltrationWithHandwechsels = 0;
        if (ultrafiltration) {
            ultrafiltrationWithHandwechsels = ultrafiltration;
        }

        if (handwechsels && handwechsels.length > 0 ) {
            handwechsels.forEach(handwechselItem => {
                //handwechselItem
                let itemHanwehselnInput = handwechselItem.inlet_volume;
                let itemHanwehselnOutput = handwechselItem.outlet_volume;
                if (itemHanwehselnInput && itemHanwehselnOutput) {
                    let itemUltrafiltration = Number(itemHanwehselnOutput) - Number(itemHanwehselnInput);
                    ultrafiltrationWithHandwechsels = Number(ultrafiltrationWithHandwechsels) + Number(itemUltrafiltration) ;
                }
            });
        }
        return ultrafiltrationWithHandwechsels;
    }

    /******************* #6920***************************/

    public static calculateTimeDiff(startTime:String, endTime:String): string {

        let hourMinStr = "";

        let startHour = Number(startTime.substring(0, 2));
        let startMinute = Number(startTime.substring(3));
        let endHour = Number(endTime.substring(0, 2));
        let endMinute = Number(endTime.substring(3));

        let startDate = new Date();
        startDate.setHours(startHour);
        startDate.setMinutes(startMinute);
        startDate.setSeconds(0);
        //console.log("startDate:",startDate);

        let endDate = new Date();
        endDate.setHours(endHour);
        endDate.setMinutes(endMinute);
        endDate.setSeconds(0);
        //console.log("endDate:",endDate);

        if ((startHour > endHour) || ( (startHour === endHour)  && (startMinute > endMinute) ) ) {
            endDate = this.addDays(endDate, 1);
            //console.log("next day endDate:",endDate);
        }

        let diffInMilliSeconds = Math.abs(endDate.getTime() - startDate.getTime()); //milli sec

        let minutes  = Math.abs(diffInMilliSeconds / (1000 * 60)); // in minutes
        //console.log ("diff in minutes=" + minutes);

        let min = Math.abs(minutes % 60);
        //console.log ("MIN RESULTS= " + Math.trunc(min));
        var hour = Math.abs((minutes-min)/60);
        let minTruncated = Math.trunc(min);

        if (hour > 0) {
            hourMinStr = hourMinStr + hour + " std";
        }

        if (minTruncated > 0) {
            hourMinStr = hourMinStr + " " + minTruncated + " min";
        }
        return hourMinStr;
    }

    // https://stackoverflow.com/questions/563406/add-days-to-javascript-date
    public static addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    /****************************************************/
}



// WEBPACK FOOTER //
// ./src/providers/datacheck/dataCheckProvider.ts